import { Route, Switch, Redirect } from 'react-router-dom'

import Ample from './routes/Ample/'
const App = () => {
 return (
   <Switch>
    <Route path='/ample' component={Ample} />
    <Route path='/' component={Ample} />
    
   </Switch>
 )
}

export default App
